<template lang="html">
  <mdb-collapse
    :toggleTag="['a']"
    :togglers="1"
    :toggleClass="['toggler mb-3']"
    :toggleText="[question]"
  >
    <p class="mt-2 faq--answer" v-html="answer"></p>
  </mdb-collapse>
</template>

<script lang="js">
  import { mdbCollapse } from "mdbvue";
  export default  {
    name: 'FaqItem',
     components: {
      mdbCollapse,
    },
    props: ['question', 'answer'],
    mounted () {

    },
    data () {
      return {

      }
    },
}
</script>

<style scoped lang="scss"></style>
